import { FC, ReactNode } from 'react';
import { styled } from '@robocorp/theme';
import { BoxProps } from '@robocorp/components';

type FieldsetProps = {
  padding?: boolean;
  narrow?: boolean;
  controls?: boolean;
  /**
   * @ignore
   */
  children?: ReactNode;
} & BoxProps;

const FieldsetStyled = styled.div<FieldsetProps>`
  display: flex;
  align-items: stretch;
  margin-bottom: 20px;
  padding-right: 16px;
  padding-top: ${({ padding }) => (padding ? '24px' : '0')};
  ${({ narrow }) => narrow && 'width: auto;'}

  ${({ controls }) =>
    controls
      ? `
      justify-content: flex-end;
      & > * {
        margin-left: 16px;
      }
    `
      : `
    & > * {
      flex: 1;
    }
  `}
`;

export const Fieldset: FC<FieldsetProps> = ({ children, ...rest }) => {
  return <FieldsetStyled {...rest}>{children}</FieldsetStyled>;
};

Fieldset.defaultProps = {
  width: 1,
};
